var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumidityVertical(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19C5.78333 19 3.89583 18.2333 2.3375 16.7C0.779167 15.1667 0 13.3083 0 11.125C0 10.025 0.208333 9.00417 0.625 8.0625C1.04167 7.12083 1.61667 6.28333 2.35 5.55L8 0L13.65 5.55C14.3833 6.28333 14.9583 7.12083 15.375 8.0625C15.7917 9.00417 16 10.025 16 11.125C16 13.3083 15.2208 15.1667 13.6625 16.7C12.1042 18.2333 10.2167 19 8 19ZM8 17V2.8L3.75 7C3.16667 7.55 2.72917 8.175 2.4375 8.875C2.14583 9.575 2 10.325 2 11.125C2 12.7417 2.58333 14.125 3.75 15.275C4.91667 16.425 6.33333 17 8 17Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidityVertical);
export default __webpack_public_path__ + "static/media/humidity_vertical.b243588fc1253faddba644da8842efa1.svg";
export { ForwardRef as ReactComponent };